import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const MainLayout = () => import('@/layouts/MainLayout.vue')
const DashboardView = () => import('@/views/DashboardView.vue')
const LoginView = () => import('@/views/LoginView.vue')
const PatientsView = () => import('@/views/PatientsView.vue')
const PatientDetailView = () => import('@/views/PatientDetailView.vue')
const TasksView = () => import('@/views/TasksView.vue')
const TrainingTasksView = () => import('@/views/TrainingTasksView.vue')
const ConsultView = () => import('@/views/ConsultView.vue')
const AppointmentsView = () => import('@/views/AppointmentsView.vue')
const TagsView = () => import('@/views/TagsView.vue')
const DiaryView = () => import('@/views/DiaryView.vue')
const PlansView = () => import('@/views/PlansView.vue')
const PlansViewSimple = () => import('@/views/PlansViewSimple.vue')
const CheckinView = () => import('@/views/CheckinView.vue')
const AssessmentsView = () => import('@/views/AssessmentsView.vue')
const DiagnosticView = () => import('@/views/DiagnosticView.vue')
const VentilatorFollowUpView = () => import('@/views/VentilatorFollowUpView.vue')
const MaterialManageView = () => import('@/views/MaterialManageView.vue')

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: '/dashboard' },
      { path: 'dashboard', name: 'dashboard', component: DashboardView },
      { path: 'patients', component: PatientsView },
      { path: 'patients/:id', component: PatientDetailView },
      {
        path: 'tasks/scale',
        name: 'scaleTasks',
        component: TasksView,
        props: { type: 'scale' }
      },
      {
        path: 'tasks/medical',
        name: 'medicalTasks',
        component: TasksView,
        props: { type: 'medical' }
      },
      {
        path: 'tasks/training',
        name: 'trainingTasks',
        component: TrainingTasksView
      },
      { path: 'consult', component: ConsultView },
      { path: 'appointments', component: AppointmentsView },
      { path: 'tags', component: TagsView },
      { path: 'diary', component: DiaryView },
      { path: 'plans', component: PlansView },
      { path: 'plans-simple', component: PlansViewSimple },
      { path: 'checkin', component: CheckinView },
      { path: 'assessments', component: AssessmentsView },
      { path: 'diagnostic', component: DiagnosticView },
      { path: 'ventilator-followup', name: 'ventilatorFollowUp', component: VentilatorFollowUpView },
      { path: 'materials', name: 'materials', component: MaterialManageView }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated

  // 如果访问的是登录页面
  if (to.path === '/login') {
    // 如果已经登录，重定向到首页
    if (isAuthenticated) {
      next('/dashboard')
    } else {
      next()
    }
  } else if (to.meta.requiresAuth !== false) {
    // 如果访问需要认证的页面
    // 如果未登录，重定向到登录页
    if (!isAuthenticated) {
      next('/login')
    } else {
      next()
    }
  } else {
    // 其他情况直接通过
    next()
  }
})

export default router
